module.exports = __webpack_public_path__ + "static/media/travel-prod-info-01.97609b96.png";